
import React, { useState, useEffect, createContext, useContext, useMemo } from 'react';
import { Modal } from 'react-bootstrap';
import { TFunction, withTranslation } from 'react-i18next';
import Form from '../containers/formNew';
import SubmitButton from '../controls/buttons/submitButtonNew';
import Button from '../controls/buttons/buttonNew';
import TextField from '../controls/fields/textFieldNew';
import ToogleButtonField from '../controls/fields/toogleField';
import './form-filter.scss';
import { ReactComponent as IconTrashSVG } from 'itd-common/assets/icons/trash.svg';
import { ReactComponent as IconEditSVG } from 'itd-common/assets/icons/edit.svg';
import { ReactComponent as IconFiltersSVG } from 'itd-common/assets/icons/icon-filters.svg';
import { ReactComponent as IconFolder } from 'itd-common/assets/icons/icon-folder.svg';
import { ReactComponent as IconCloseSVG } from 'itd-common/assets/icons/close.svg';
import { ReactComponent as FilterListSvg } from 'itd-common/assets/icons/filterList.svg';
import { UtilService } from '../../services/UtilService';
import SideModal from './side-modal';
import { getCookie, setSessionCookie } from '../../helpers/CookieHelper';
import DropdownButton from '../controls/buttons/dropdownButton';
import { DateObject } from 'react-multi-date-picker';
export type RenderArea = 'main' | 'modal';
export const FilterRenderContext = createContext<RenderArea>('main');

interface IProps {
  header?: React.ReactElement;
  children: React.ReactNode;
  onSubmit?: (event: React.FormEvent<HTMLFormElement>) => void;
  clear?: () => void;
  model: [any, (m: any) => void];
  hidden?: boolean;
  t: TFunction;
  page?: string;
  emptyClearStates?: Record<string, any>;
  isAllFilterAvailable?: boolean;
  isSearchAvailable?: boolean
}

interface ISavedFilterSearch {
  name: string;
  isDefault: boolean;
  model: any[];
}

const KEYSAVEDSEARCH: string = '-saved-filters';
const T_PREFIX: string = 'shared.formFilter.';

const FormFilter = ({ header, hidden, children, onSubmit, clear, model, t, page, emptyClearStates, isAllFilterAvailable = true, isSearchAvailable = true }: IProps) => {
  const [hiddenModal, setHiddenModal] = useState(true);
  const [showMoreFilters, setShowMoreFilters] = useState(false);
  const [showSavedFilters, setShowSavedFilters] = useState(false);
  const [toggleDetail, setToggleDetail] = useState(false);
  const [showEditFormSavedFilters, setShowEditFormSavedFilters] = useState(false);
  const [formSaveFilter, setFormSaveFilter] = useState<ISavedFilterSearch>({ name: '', isDefault: false, model: [] });
  const [savedFilterSearch, setSavedFilterSearch] = useState<ISavedFilterSearch[]>([]);
  const [editingIndex, setEditingIndex] = useState<number | null>(null);
  const [previousModel, setPreviousModel] = useState<any | null>(null);

  /** -------------------------
   *  TOUR (popover por pasos)
   * ------------------------- */
  const [tourOpen, setTourOpen] = useState<boolean>(false);
  const [tourStep, setTourStep] = useState<number>(0); // 0 = Todos los filtros, 1 = Guardar busqueda


  const TOUR_COOKIE = 'formFilterTourShown'; // nombre de la cookie de session

  // Tour deshabilitado a pedido (no debe aparecer en la página). Código conservado comentado por si se reactiva.
  useEffect(() => {
    // const alreadyShown = getCookie(TOUR_COOKIE);
    // // Si ninguno de los dos pasos tiene UI disponible en esta página (ej. isAllFilterAvailable=false),
    // // no abrir el tour: el paso 0 no renderiza su popover y el overlay oscuro queda sin salida.
    // if (!alreadyShown && (isAllFilterAvailable || isSearchAvailable)) {
    //   setTourOpen(true);
    //   setTourStep(isAllFilterAvailable ? 0 : 1);
    //   setSessionCookie(TOUR_COOKIE, '1'); // cookie de session; se borra al cerrar navegador
    // } else {
    //   // La cookie existe: no mostrar el tour
    //   setTourOpen(false);
    // }
  }, []);

  const handleTourPrev = () => {
    if (tourStep === 1 && isAllFilterAvailable) setTourStep(0);
  };
  const handleTourNext = () => {
    if (tourStep === 0 && isSearchAvailable) {
      setTourStep(1);
    } else {
      setTourOpen(false);
    }
  };
  const handleTourClose = () => setTourOpen(false);

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (onSubmit) {
      hidden && setHiddenModal(true);
      onSubmit(event);
    }
  };

  useEffect(() => {
    setTimeout(loadSavedFilterSearch, 2000); // safeLoad savedFilter con setTimeout
  }, [page]);

  const loadSavedFilterSearch = () => {
    const storageKey = `${page}${KEYSAVEDSEARCH}`;
    const values: ISavedFilterSearch[] = JSON.parse(localStorage.getItem(storageKey) ?? '[]');
    setSavedFilterSearch(values);
    let def = values.find((f) => f.isDefault && f.model);
    //Tenemos que hacer la siguiente transformación de tipo de datoporque solo se almacenan en tipo numerico en el localStorage las fechas
    if ((def?.model as any)?.dateRange && typeof (def?.model as any)["dateRange"][0] === "number") {
      let values = (def?.model as any)["dateRange"];
      let dateFrom = new Date(values[0]);
      let dateTo = new Date(values[1]);
      (def?.model as any).dateRange = [new DateObject(dateFrom), new DateObject(dateTo)];
    }
    if (def?.model)
      model[1](def.model);
  };

  const saveFilterSearch = () => {
    if (!formSaveFilter.name.trim()) return;
    const storageKey = `${page}${KEYSAVEDSEARCH}`;
    let items: ISavedFilterSearch[] = [...savedFilterSearch];
    if (formSaveFilter.isDefault) {
      items = items.map((f) => ({ ...f, isDefault: false }));
    }

    items.push({
      name: formSaveFilter.name,
      isDefault: formSaveFilter.isDefault,
      model: model[0],
    });

    localStorage.setItem(storageKey, JSON.stringify(items));
    setSavedFilterSearch(items);
    setFormSaveFilter({ name: '', isDefault: false, model: [] });
    // model[1](emptyClearStates); //Limpiamos el modal
  };

  const deleteFilterSearch = (name: string) => {
    const storageKey = `${page}${KEYSAVEDSEARCH}`;
    const items = savedFilterSearch.filter((f) => f.name !== name);
    localStorage.setItem(storageKey, JSON.stringify(items));
    setSavedFilterSearch(items);

    if (showEditFormSavedFilters) cancelEdit();
  };

  const startEdit = (item: ISavedFilterSearch, index: number) => {
    setFormSaveFilter({ name: item.name, isDefault: item.isDefault, model: [] });
    setEditingIndex(index);
    if (model) {
      setPreviousModel(model[0]); // guardamos estado actual
      model[1](item?.model); // cargamos el model en el formulario principal
    }
    setShowEditFormSavedFilters(true);
  };

  const updateFilterSearch = () => {
    if (editingIndex === null) return;

    const storageKey = `${page}${KEYSAVEDSEARCH}`;
    let items: ISavedFilterSearch[] = JSON.parse(localStorage.getItem(storageKey) ?? '[]');

    if (formSaveFilter.isDefault) {
      items = items.map((f, i) => (i === editingIndex ? f : { ...f, isDefault: false }));
    }

    items[editingIndex] = {
      name: formSaveFilter.name,
      isDefault: formSaveFilter.isDefault,
      model: model ? model[0] : {},
    };

    localStorage.setItem(storageKey, JSON.stringify(items));

    if (model[1])
      model[1](previousModel);
    setSavedFilterSearch(items);
    setEditingIndex(null);
    setFormSaveFilter({ name: '', isDefault: false, model: [] });
    setPreviousModel(null);
    setShowEditFormSavedFilters(false);
  };

  const cancelEdit = () => {
    if (previousModel && model[1]) {
      model[1](previousModel);
    }
    setEditingIndex(null);
    setFormSaveFilter({ name: '', isDefault: false, model: [] });
    setPreviousModel(null);
    setToggleDetail(false);
    setShowEditFormSavedFilters(false);
  };

  const onCloseModal = () => {
    if (showEditFormSavedFilters) {
      cancelEdit();
    } else {
      setFormSaveFilter({ name: '', isDefault: false, model: [] });
      setShowSavedFilters(false);
    }
  };

  const finalizeCloseCleanup = () => {
    (document.activeElement as HTMLElement | null)?.blur?.();
    document.body.classList.remove('modal-open', 'offcanvas-open');
    (document.documentElement as HTMLElement).style.overflow = '';
    document
      .querySelectorAll('.modal-backdrop, .offcanvas-backdrop, .side-modal-backdrop')
      .forEach((el) => el.parentElement?.removeChild(el));
  };

  const onCloseShowFilterModal = () => {
    setShowMoreFilters(false);
    setTimeout(finalizeCloseCleanup, 300); // safeClose del modal
  };

  const onHandleSaveChanges = () => {
    if (showEditFormSavedFilters) {
      updateFilterSearch();
    } else {
      saveFilterSearch();
    }
    setToggleDetail(false);
  };

  const onHandleApplySavedSearch = (item: ISavedFilterSearch) => {
    let def = item;
    //Tenemos que hacer la siguiente transformación de tipo de datoporque solo se almacenan en tipo numerico en el localStorage las fechas
    if ((def?.model as any)?.dateRange && typeof (def?.model as any)["dateRange"][0] === "number") {
      let values = (def?.model as any)["dateRange"];
      let dateFrom = new Date(values[0]);
      let dateTo = new Date(values[1]);
      (def?.model as any).dateRange = [new DateObject(dateFrom), new DateObject(dateTo)];
    }
    model[1](item.model);
    onCloseModal();
  };

  /** -------------------------
   *  Orden de children (modal)
   * ------------------------- */
  const childrenArray = React.Children.toArray(children);
  const getSlot = (child: React.ReactNode): 'primary' | 'advanced' | undefined =>
    React.isValidElement(child) ? (child.props as any)?.slot : undefined;

  const orderedChildrenForModal = childrenArray.sort((a, b) => {
    const slotA = getSlot(a);
    const slotB = getSlot(b);
    const weight = (slot?: string) => (slot === 'primary' ? 0 : 1);
    return weight(slotA) - weight(slotB);
  });

  return (
    <div className="filter-accordion form-filter">
      {/* Mobile modal when hidden=true */}
      <Modal show={!hiddenModal} size="lg" scrollable onHide={() => setHiddenModal(true)}>
        <div className="row">
          <div className="col-md-12 d-flex justify-content-end">
            <a
              {...(UtilService.isMobilePlatform() ? {} : { type: 'button' })}
              className="me-5 mt-5"
              onClick={() => setHiddenModal(true)}
            >
              <IconCloseSVG />
            </a>
          </div>
        </div>
        <div className="row scrollable-container mb-5">
          <Form onSubmit={handleSubmit} model={model} emptyClearStates={emptyClearStates}>
            <>
              <div className="row ms-5 mt-5 mb-5">
                <h3 className="mb-1">{t('filters')}</h3>
                <p className="text-gray">{t('elementsSelectedSearch')}</p>
              </div>
              <section className="row g-3">
                <FilterRenderContext.Provider value="modal">{children}</FilterRenderContext.Provider>
              </section>
              <div className="row mt-5 mb-5 justify-content-end">
                <div className="col-md-3 d-flex justify-content-end align-items-center">
                  {clear && (
                    <a
                      {...(UtilService.isMobilePlatform() ? {} : { type: 'button' })}
                      className="fw-bold"
                      onClick={clear}
                    >
                      {t('clear')} <IconTrashSVG />
                    </a>
                  )}
                </div>
                <div className="col-md-3">
                  <SubmitButton label="query" className={`mt-0 ${UtilService.isMobilePlatform() ? 'submitNative' : ''}`} />
                </div>
              </div>
            </>
          </Form>
        </div>
      </Modal>

      {/* Desktop view */}
      {/* {hidden ? (
        <a {...(UtilService.isMobilePlatform() ? {} : { type: 'button' })} onClick={() => setHiddenModal(false)}>
          <span className="icon-filter">
            <IconFiltersSVG />
          </span>
        </a>
      ) : ( */}
      <div className="card-box">
        <div className="row">
          <div className="col-md-12 p-0">
            <Form onSubmit={handleSubmit} model={model} emptyClearStates={emptyClearStates}>
              <>
                <div className="row filter-header">
                  <div className="col-sm-8 col-md col-lg-9 d-flex align-items-center mt-0 pe-0 pb-2 pb-md-5">
                    <span className="icon-filter">
                      <IconFiltersSVG />
                    </span>

                    <h4 className="w-80 mb-1 fw-bold">
                      {t(`${T_PREFIX}title`)}
                    </h4>
                  </div>
                  <div className="col-sm-4 col-lg-3 d-flex justify-content-end p-0">
                    {/* Popúp: Guardar búsqueda */}
                    {isSearchAvailable && (<div className={`save-search-anchor ${tourOpen && tourStep === 1 ? 'tour-highlight' : ''}`}>
                      <Button
                        className="save-search"
                        color="transparent"
                        onClick={() => setShowSavedFilters(true)}
                        label={t(`${T_PREFIX}saveSearch`)}
                        prefix={<IconFolder />}
                      />
                      {/* Tour deshabilitado a pedido: popover comentado, se conserva por si se reactiva.
                      <div
                        id="tour-popover-save"
                        className={`tour-popover ${tourOpen && tourStep === 1 ? 'is-open' : ''}`}
                        role="dialog"
                        aria-modal="true"
                        aria-labelledby="tour-title-save"
                      >
                        <div className="tour-header">
                          <span id="tour-title-save" className="tour-title">{t(`${T_PREFIX}saveSearch`)}</span>
                          <button aria-label="Cerrar" type="button" onClick={handleTourClose}><IconCloseSVG /></button>
                        </div>
                        <p className="tour-description">
                          {t(`${T_PREFIX}popup.saveSearch.text1`)} <strong>{t(`${T_PREFIX}popup.saveSearch.text2`)}</strong> {t(`${T_PREFIX}popup.saveSearch.text3`)}
                        </p>
                        <div className="tour-actions">
                          <button className="tour-prev" type="button" onClick={handleTourPrev}>
                            {t('common.action.before')}
                          </button>
                          <button className="tour-next" type="button" onClick={handleTourNext}>
                            {t('common.action.next')}
                          </button>
                        </div>
                      </div>
                      */}
                    </div>)}
                  </div>
                </div>
                <FilterRenderContext.Provider value="main">
                  <div className="row g-3">{children}</div>
                </FilterRenderContext.Provider>
                <div className="row mt-5 justify-content-end">
                  <div className="col-md-6 d-flex align-items-center">
                    {/* Todos los filtros */}
                    {isAllFilterAvailable && (
                      <div className={`all-filters-anchor ${tourOpen && tourStep === 0 ? 'tour-highlight' : ''}`}>
                        <a type="button" className="d-flex" onClick={() => setShowMoreFilters(true)} aria-haspopup="dialog" aria-controls="tour-popover-all">
                          <FilterListSvg className="icon-black ps-1" />
                          <span className="all-filters-button">{t(`${T_PREFIX}allFilters`)}</span>
                        </a>
                        {/* Tour deshabilitado a pedido: popover comentado, se conserva por si se reactiva.
                        <div
                          id="tour-popover-all"
                          className={`tour-popover ${tourOpen && tourStep === 0 ? 'is-open' : ''}`}
                          role="dialog"
                          aria-modal="true"
                          aria-labelledby="tour-title-all"
                        >
                          <div className="tour-header">
                            <span id="tour-title-all" className="tour-title">{t(`${T_PREFIX}popup.moreFilters`)}</span>
                            <button aria-label="Cerrar" type="button" onClick={handleTourClose}><IconCloseSVG /></button>
                          </div>
                          <p className="tour-description">
                            {t(`${T_PREFIX}popup.allFilterDescription.text1`)} <strong>{t(`${T_PREFIX}popup.allFilterDescription.text2`)}</strong> {t(`${T_PREFIX}popup.allFilterDescription.text3`)}
                          </p>
                          <div className="tour-actions">
                            <button className="tour-prev" type="button" onClick={handleTourPrev}>
                              {t('common.action.before')}
                            </button>
                            <button className="tour-next" type="button" onClick={handleTourNext}>
                              {t('common.action.next')}
                            </button>
                          </div>
                        </div>
                        */}
                      </div>
                    )}
                  </div>

                  <div className="col-md-6 pe-0 d-flex justify-content-end align-items-center">
                    {clear && <Button className="mt-0" type="button" label={t('clear')} disabled={emptyClearStates === model[0]} color="white" onClick={clear} />}
                    <SubmitButton label="query" className="mt-0 ms-3" />
                  </div>
                </div>
                {/* Overlay del tour deshabilitado a pedido:
                {tourOpen && <div className="tour-overlay" aria-hidden="true" />}
                */}
              </>
            </Form>
          </div>
        </div>
      </div>
      {/* )} */}
      {/* SideModal: Más filtros */}
      <SideModal
        show={showMoreFilters}
        onClose={onCloseShowFilterModal}
        title={t('filters')}
      >
        <div className="filter-accordion form-filter mb-4">
          <Form onSubmit={handleSubmit} model={model} emptyClearStates={emptyClearStates}>
            <>
              <FilterRenderContext.Provider value="modal">
                <section className="row g-3 pt-3">{orderedChildrenForModal}</section>
              </FilterRenderContext.Provider>
              <div className="row mt-4">
                <div className="col d-flex justify-content-end">
                  {clear && <Button type="button" className="mt-0" label={t('clear')} color="white" onClick={clear} />}
                  <SubmitButton label="query" className="mt-0 ms-3" />
                </div>
              </div>
            </>
          </Form>
        </div>
      </SideModal>
      {/* SideModal: Guardar búsqueda */}
      <SideModal
        show={showSavedFilters}
        onClose={onCloseModal}
        title={showEditFormSavedFilters ? t(`${T_PREFIX}editSearch`) : t(`${T_PREFIX}saveSearch`)}
      >
        <div className="saved-filters">
          <div className="row">
            {
              savedFilterSearch.length > 0 &&
              <h4 className="title-saved-filters">{t(`${T_PREFIX}mySearchs`)}</h4>
            }
            <ul className="saved-filters-list">
              {savedFilterSearch.map((item, index) => (
                <li key={`${item.name}-${index}`} className="saved-filter-item">
                  <span className="filter-name" onClick={() => onHandleApplySavedSearch(item)}>{item.name}</span>
                  <div className="filter-actions">
                    <button type="button" className="action-btn" onClick={() => startEdit(item, index)}>
                      <IconEditSVG />
                    </button>
                    <button type="button" className="action-btn" onClick={() => deleteFilterSearch(item.name)}>
                      <IconTrashSVG />
                    </button>
                  </div>
                </li>
              ))}
            </ul>
          </div>
          {
            savedFilterSearch.length > 0 &&
            <div className="divider"></div>
          }
          <div className="row">
            <Form model={[formSaveFilter, setFormSaveFilter]}>
              <>
                <h4 className="title-saved-filters pb-5">{t(`${T_PREFIX}newSearch`)}</h4>
                <div className="my-3">
                  <TextField
                    placeholder={t(`${T_PREFIX}writeSearch`)}
                    attr="name"
                    label={t(`${T_PREFIX}name`)}
                  />
                </div>
                <div className="mb-3">
                  <ToogleButtonField attr="isDefault" label={t(`${T_PREFIX}defaultSearch`)} />
                </div>
              </>
            </Form>
          </div>
          <Form onSubmit={handleSubmit} model={model} emptyClearStates={emptyClearStates}>
            <>
              <div className="row d-flex justify-content-center">
                <div className="col-md-12 px-1">
                  <DropdownButton onClick={() => setToggleDetail(!toggleDetail)} label={t(`${T_PREFIX}allFilters`)} />
                </div>

                {toggleDetail && (
                  <FilterRenderContext.Provider value="modal">
                    <section className="row g-3 m-0 detail-filters">{orderedChildrenForModal}</section>
                  </FilterRenderContext.Provider>
                )}
              </div>
              <div className="row mt-4">
                <div className="col-md-12 d-flex justify-content-end">
                  <Button className="mt-0 me-2" label={t('common.action.cancel')} color="white" type="button" onClick={onCloseModal} />
                  <Button className="mt-0" label={t('common.action.save')} color="primary" type="button" onClick={onHandleSaveChanges} />
                </div>
              </div>
            </>
          </Form>
        </div>
      </SideModal>
    </div>
  );
};

export default withTranslation()(FormFilter);

/* FilterBlock  */
export interface FilterBlockProps extends React.HTMLAttributes<HTMLDivElement> {
  slot?: 'primary' | 'advanced';
  primaryClass?: string;
  advancedClass?: string;
  children: React.ReactNode;
}

export const FilterBlock: React.FC<FilterBlockProps> = ({
  slot,
  primaryClass = 'col-md-3',
  advancedClass = 'col-md-12',
  className,
  children,
  ...rest
}) => {
  const area = useContext(FilterRenderContext);
  const appliedClass = area === 'main' ? primaryClass : advancedClass;
  const mergedClassName = [appliedClass, className, slot === 'primary' ? 'is-primary' : 'is-advanced']
    .filter(Boolean)
    .join(' ');
  return (
    <div {...rest} className={mergedClassName} slot={slot} data-area={area}>
      {children}
    </div>
  );
};